/**
 * HeaderCenterUniba component.
 * @module components/Header/HeaderCenterUniba
 */

import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { useSelector } from 'react-redux';
import {
    Header,
    HeaderRightZone,
    Row,
    Col,
} from 'design-react-kit';
import { Logo } from 'design-comuni-plone-theme/components/ItaliaTheme';

const messages = defineMessages({
    logoSubsiteAlt: {
        id: 'logo-subsite-alt',
        defaultMessage: 'Logo',
    },
    subsiteUniversalLink: {
        id: 'link-subsite-homepage-title',
        defaultMessage: 'homepage',
    },
});

const HeaderCenterUniba = () => {
    const intl = useIntl();
    const subsite = useSelector((state) => state.subsite?.data);
    const logoSubsite = subsite?.subsite_logo && (
        <figure className="icon">
            <Logo alt={intl.formatMessage(messages.logoSubsiteAlt)} />
        </figure>
    );

    return (
        <Header small={false} theme="" type="center">
            <div className="ui container">
                <Row>
                    <Col>
                        <div className="it-header-center-content-wrapper">
                            <div className="it-brand-wrapper" id="portal-logo">
                                <a
                                    href="https://www.uniba.it"
                                    title={intl.formatMessage(messages.subsiteUniversalLink)}
                                    target="_blank"
                                    className="main-header_uniba"
                                    rel="noopener noreferrer"
                                >
                                    {subsite?.subsite_logo ? (
                                        logoSubsite
                                    ) : (
                                        <Logo className="icon" />
                                    )}
                                </a>
                            </div>
                            <div></div>
                            <HeaderRightZone>
                                {/* <SocialHeader /> */}
                                {/* <HeaderSearch /> */}
                            </HeaderRightZone>
                        </div>
                    </Col>
                </Row>
            </div>
        </Header>
    );
};

export default HeaderCenterUniba;
